import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router'

// VM 생성 페이지가 목록으로 돌아가며 남기는 한 줄. 페이지는 끝나면 사라지므로 결과 문장은 경로의 state 로
// 목록에 넘기고, 목록이 그 줄을 알림으로 세운다 — 관리자의 VM 목록과 사용자의 내 VM 이 같은 방법으로 받는다.

/** 목록 위에 서는 한 줄. 확인은 초록, 오류는 빨강. 경로의 state 에는 `{ notice }` 로 싣는다. */
export type Notice = { tone: 'ok' | 'danger'; text: string }

function noticeOf(state: unknown): Notice | null {
  const n = (state as { notice?: Partial<Notice> } | null)?.notice
  if (!n || typeof n.text !== 'string' || (n.tone !== 'ok' && n.tone !== 'danger')) return null
  return { tone: n.tone, text: n.text }
}

/**
 * 경로가 싣고 온 알림. 받은 뒤에는 그 state 를 지운다 — 브라우저가 새로고침에도 history 의 state 를 지켜
 * 남겨 두면 다시 읽을 때마다 같은 알림이 선다. 알림은 화면의 것이라 지운 뒤에도 닫기 전까지 남는다.
 */
export function useArrivedNotice(): [Notice | null, (n: Notice | null) => void] {
  const { state, pathname } = useLocation()
  const nav = useNavigate()
  const arrived = state != null && noticeOf(state) !== null
  const [notice, setNotice] = useState<Notice | null>(() => noticeOf(state))
  useEffect(() => {
    if (arrived) void nav(pathname, { replace: true, state: null })
  }, [arrived, nav, pathname])
  return [notice, setNotice]
}
